class ct_mainprod_images_wrapper extends HTMLElement {
  constructor() {
    super();
    Array.from(this.querySelector(".ct-images-pickers").children).forEach((picker) => {
      picker.addEventListener("click", () => {
        this.selectImage(picker);
      });
    });
  }
  selectImage(element) {
    const pickers = this.querySelector(".ct-images-pickers").children;
    const images = this.querySelector(".ct-image-visible");
    const index = element.getAttribute("img-index");    
    Array.from(pickers).forEach((picker) => {
      picker.removeAttribute("selected");
    });
    Array.from(images.children).forEach((img) => {
      img.removeAttribute("selected");
    });
    element.setAttribute("selected", "");
    images.querySelector("[img-index='" + index + "']").setAttribute("selected", "");
    const scrollContainer = this.querySelector(".ct-images-pickers");
    const containerHeight = scrollContainer.clientHeight;
    const itemHeight = element.offsetHeight;
    const gap = 2;
    const targetPosition = itemHeight - 4;
    const itemOffset = element.offsetTop - scrollContainer.offsetTop;
    const scrollPosition = itemOffset - targetPosition;
    if(index == "1") {
      scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      if (scrollPosition >= 0 && scrollPosition + containerHeight <= scrollContainer.scrollHeight) {
        scrollContainer.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      } else {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        });
      }
    }
  }
}

customElements.define("ct-images-wrapper", ct_mainprod_images_wrapper);